import React from "react"
import { useTranslation } from "react-i18next"

import { Content } from "pages/dashboard/elements"
import ProfileNavigation from "components/Layout/ProfileNavigation"
import Title from "components/ui/Title"
import PurchasedProducts from "components/PurchasedProducts"

const InvoicesPage = () => {
  const { t } = useTranslation()

  return (
    <Content data-testid="invoices-page">
      <Title>{t("pages.invoices.title")}</Title>
      <ProfileNavigation />
      <PurchasedProducts />
    </Content>
  )
}

export default InvoicesPage
